import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../components/SocketContext';
import { useReward } from 'react-rewards';
import './Overlay.css'; // Import the CSS for the overlay

let index = '0';

const Overlay = () => {

    const socket = useContext(SocketContext);
    const { reward, isAnimating } = useReward('rewardId', 'confetti', {lifetime: 100});
    const [messageObj, setMessageObj] = useState({
        'name': '',
        'message': '',
        'duration': 5000
    });

    useEffect(() => {
        socket.on('presentwinners', (data) => {
            setMessageObj({
                'name': 'Winner',
                'message': data.winners[0].playerName,
                'duration': 0
            });
            setTimeout(() => {
                setMessageObj({
                    'message': '',
                    'duration': 0
                });
            }, 3500);

        });

        socket.on('showoverlay', (data) => {

            setMessageObj({
                'name': data.name,
                'message': data.message,
                'duration': 0
            });

            if (data.duration && data.duration > 0) {
                setTimeout(() => {
                    setMessageObj({
                        'message': '',
                        'duration': 0
                    });
                }, data.duration);
            }
        });

        socket.on('hideoverlay', (data) => {

            setMessageObj({
                'message': '',
                'duration': 0
            });
        });

        return () => {
            socket.off('presentwinners');
            socket.off('showoverlay');
            socket.off('hideoverlay');
        };
    }, []);


    if (messageObj.message === '') {
        index = '0';
    } else {
        index = '1000';
    }

    return (
        <div id="overlay" className="overlay" style={{ zIndex: index }}>
            <div className="overlay-content">
                <h4>{messageObj.name}</h4>
                <span id="rewardId" ><p>{messageObj.message}</p></span>
            </div>
        </div>
    );
};

export default Overlay;